import React from 'react'
import { BatchVoucherReportDataType, TotalBatchVoucherDataType } from '../../../../redux/reports/reportsType'
import { TableLoader } from '../../../commons'
import BatchVoucherTableHeader from './BatchVoucherTableHeader'
import BatchVoucherTableData from './BatchVoucherTableData'

type AppProps = {
  fetching: boolean;
  client_code: number;
  company_name?: any;
  start_date: string;
  end_date: string;
  currencySign: string | undefined;
  batchVoucherData: [] | BatchVoucherReportDataType[]
  totalBatchVoucherData: TotalBatchVoucherDataType
}

const BatchVoucherTable = ({
  fetching,
  client_code,
  batchVoucherData,
  totalBatchVoucherData,
  company_name,
  start_date,
  end_date,
  currencySign
}: AppProps) => {
  return (
    <div >
      {
        fetching ?
          <TableLoader
            Rows={10}
            ColumnPerRow={8}
          /> :
          <div className="jobsType" style={{ overflowX: "scroll" }}>
            <table className="table table-bordered thead-light">
              <thead className='text-start'>
                <BatchVoucherTableHeader />
              </thead>
              <tbody>
                <BatchVoucherTableData
                  batchVoucherData={batchVoucherData}
                  totalBatchVoucherData={totalBatchVoucherData}
                  currencySign={currencySign}
                />
              </tbody>
            </table>
          </div>
      }
    </div>
  )
}

export default BatchVoucherTable